import { render, staticRenderFns } from "./OtherIdsEditPanelDialog.vue?vue&type=template&id=2534aa48"
import script from "./OtherIdsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./OtherIdsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports